import get from 'lodash.get';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { getProductionTimeNote } from '../shared/helpers/productionTimeNoteHelper';
import { getCheckoutLeadTimeCopy } from '../helpers/getCheckoutLeadTimeCopy';
import { useIntl } from 'dibs-react-intl';
import styles from './styles/CheckoutShippingDetails.scss';

const CheckoutShippingDetails = ({ showLeadTime, transaction, item }) => {
    const intl = useIntl();
    const leadTime = get(transaction, 'leadTime.value') || get(transaction, 'sku.leadTime');
    const itemLocation = get(item, 'address.itemAddress');
    const note = getProductionTimeNote({ transaction });

    return (
        <div className={styles.container}>
            <div className={styles.shippingDetailsContainer}>
                <FormattedMessage
                    id="checkout.CheckoutDeliveryOptions.shipsFrom"
                    defaultMessage="<bold>Ships from:</bold> {location}"
                    values={{
                        bold: chunks => <span className={styles.detailsLabel}>{chunks}</span>,
                        location: <span className={styles.shippingDetails}>{itemLocation}</span>,
                    }}
                />
            </div>
            {showLeadTime && (
                <div className={styles.shippingDetailsContainer}>
                    <FormattedMessage
                        id="checkout.CheckoutLeadTime.title"
                        defaultMessage="<bold>Production Time:</bold> {leadTimeMessage}"
                        values={{
                            bold: chunks => (
                                <span className={styles.detailsLabel} data-tn="lead-time-title">
                                    {chunks}
                                </span>
                            ),
                            leadTimeMessage: (
                                <span className={styles.shippingDetails} data-tn="lead-time-label">
                                    <FormattedMessage
                                        id="checkout.CheckoutLeadTime.label"
                                        defaultMessage="It will take {leadTime} to make this piece."
                                        values={{ leadTime: getCheckoutLeadTimeCopy(leadTime) }}
                                    />
                                </span>
                            ),
                        }}
                    />
                    {note && (
                        <div>
                            <FormattedMessage
                                id="checkout.CheckoutLeadTimeNote.title"
                                defaultMessage="<bold>NOTE</bold>: {note}"
                                values={{
                                    bold: chunks => (
                                        <span
                                            className={styles.detailsLabel}
                                            data-tn="lead-time-title"
                                        >
                                            {chunks}
                                        </span>
                                    ),
                                    note: (
                                        <span className={styles.shippingDetails}>
                                            {intl.formatMessage(note)}
                                        </span>
                                    ),
                                }}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

CheckoutShippingDetails.propTypes = {
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    showLeadTime: PropTypes.bool,
};

export default createFragmentContainer(CheckoutShippingDetails, {
    item: graphql`
        fragment CheckoutShippingDetails_item on Item {
            address {
                itemAddress: displayCityStateCountry(fullCountryName: true)
            }
        }
    `,
    transaction: graphql`
        fragment CheckoutShippingDetails_transaction on Transaction {
            ...productionTimeNoteHelper_transaction @relay(mask: false)
            sku {
                leadTime(pageType: Checkout)
            }
            leadTime {
                value
            }
        }
    `,
});
